import React, { useMemo, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import Swal from 'sweetalert2';

const StudentInterest = () => {
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState('');
	const [formData, setFormData] = useState({
		full_name: '',
		phone: '',
		school_level: '',
		school: 'University of Abuja',
		pickup_location: 'boys_hostel_mini_campus',
		will_join_sunday: true,
		notes: '',
		number_of_people: ''
	});

	
const Toast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true
  });

	// Get system IP for QR code (test mode)
	const getSystemIP = () => {
		// For test mode, use a common local network IP
		// In production, this should come from environment variables
		return '172.16.159.119:3000';
	};
	
	const formUrl = useMemo(() => {
		return `http://${getSystemIP()}/studentInterest`;
	}, []);

	// API Base URL - prefer device host for mobile access
	const deriveApiBase = () => {
		// Force production URL when deployed
		if (window.location.hostname === 'rccgtr.net' || window.location.hostname.includes('rccgtr')) {
		  return 'https://rccgtr.net/api';
		}
		
		// Development only
		if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
		  return process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
		}
		
		// Fallback to relative path
		return '/api';
	  };
	const API_BASE_URL = deriveApiBase();

	// Pickup locations based on school
	const pickupLocations = {
		'University of Abuja': [
			{ value: 'boys_hostel_mini_campus', label: 'Boys Hostel (Mini Campus)' },
			{ value: 'boys_hostel_main_campus', label: 'Boys Hostel (Main Campus)' },
			{ value: 'girls_hostel_main_campus', label: 'Girls Hostel (Main Campus)' },
			{ value: 'permanent_site_gate', label: 'Permanent Site Gate' },
			{ value: 'ido_junction', label: 'Ido Junction' },
			{ value: 'saoka_bridge_immigration', label: 'Saoka Bridge (Immigration)' },
			{ value: 'lugbe_car_wash', label: 'Lugbe by Car Wash' },
			{ value: 'lugbe_police_sign_post', label: 'Lugbe by Police Sign Post' }
		],
		'Nasarawa State University': [
			{ value: 'school_gate', label: 'School Gate' },
			{ value: 'keffi_bridge', label: 'Keffi Bridge' },
			{ value: 'maraba_junction', label: 'Maraba Junction' },
			{ value: 'nyanya_bridge', label: 'Nyanya Bridge' }
		]
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		
		try {
			setLoading(true);
			const response = await fetch(`${API_BASE_URL}/students`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(formData)
			});
			
			const data = await response.json();
			
			if (data.success) {
				Toast.fire({
					icon: 'success',
					title: 'Thank you! Your interest has been submitted successfully.',
					text: 'Your interest has been submitted successfully.',
					timer: 2000,
					showConfirmButton: false
				});
				// setMessage('Thank you! Your interest has been submitted successfully.');
				setFormData({
					full_name: '',
					phone: '',
					school_level: '',
					school: 'University of Abuja',
					pickup_location: 'boys_hostel_mini_campus',
					will_join_sunday: true,
					notes: '',
					number_of_people: ''
				});
			} else {
				Toast.fire({
					icon: 'error',
					title: 'Failed to submit form. Please try again.',
					timer: 2000,
					showConfirmButton: false
				});
				// setMessage('Failed to submit form. Please try again.');
			}
		} catch (error) {
			console.error('Error submitting form:', error);
			Toast.fire({
				icon: 'error',
				title: 'Error submitting form. Please check your connection and try again.',
				timer: 2000,
				showConfirmButton: false
			});
			// setMessage('Error submitting form. Please check your connection and try again.');
		} finally {
			setLoading(false);
		}
	};

	const handleSchoolChange = (e) => {
		const newSchool = e.target.value;
		setFormData({
			...formData,
			school: newSchool,
			pickup_location: pickupLocations[newSchool][0].value
		});
	};

	return (
		<div className="min-h-screen flex items-center justify-center p-6">
			<div className="w-full max-w-2xl bg-white rounded-2xl shadow p-6">
				<h1 className="text-xl font-bold text-indigo-900 text-center">Student Interest</h1>
				<p className="text-center text-sm text-gray-600">Scan and indicate interest for this Sunday service</p>
				
				{/* Message Display */}
				{message && (
					<div className={`mt-4 p-4 rounded-lg ${
						message.includes('successfully') 
							? 'bg-green-100 text-green-800'
							: 'bg-red-100 text-red-800'
					}`}>
						{message}
						<button 
							onClick={() => setMessage('')}
							className="float-right font-bold"
						>
							×
						</button>
					</div>
				)}

				<div className="flex justify-center my-6">
					<QRCodeCanvas value={formUrl} size={180} includeMargin />
		
				</div>
				<h1 className="text-xl font-bold text-indigo-900 text-center">Yes, I will join this Sunday</h1>

				<form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
					<input 
						className="border p-3 rounded" 
						placeholder="Full name" 
						value={formData.full_name}
						onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
						required
					/>
					<input 
						className="border p-3 rounded" 
						placeholder="Phone number" 
						value={formData.phone}
						onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
						required
					/>
					{/* <input 
						className="border p-3 rounded md:col-span-2" 
						placeholder="School / Department" 
						value={formData.school_level}
						onChange={(e) => setFormData({ ...formData, school_level: e.target.value })}
						required
					/> */}
					<select 
						className="border p-3 rounded"
						value={formData.school}
						onChange={handleSchoolChange}
						required
					>
						<option value="University of Abuja">University of Abuja</option>
						<option value="Nasarawa State University">Nasarawa State University</option>
					</select>
					
					<select 
						className="border p-3 rounded"
						value={formData.pickup_location}
						onChange={(e) => setFormData({ ...formData, pickup_location: e.target.value })}
						required
					>
						{pickupLocations[formData.school].map(location => (
							<option key={location.value} value={location.value}>
								{location.label}
							</option>
						))}
					</select>
					<select
					className="border p-3 rounded md:col-span-2"
					value={formData.school_level}
					onChange={(e) => setFormData({ ...formData, school_level: e.target.value })}
					required
					>
					<option value="">Select Level</option>
					<option value="100 Level">100 Level</option>
					<option value="200 Level">200 Level</option>
					<option value="300 Level">300 Level</option>
					<option value="400 Level">400 Level</option>
					<option value="500 Level">500 Level</option>
					<option value="600 Level">600 Level</option>
					<option value="PGD">PGD</option>
					<option value="Masters">Masters</option>
					<option value="PhD">PhD</option>
					</select>
					<input 
						className="border p-3 rounded" 
						type="number"
						min="0"
						max="10"
						placeholder="Number of people you are inviting" 
						value={formData.number_of_people}
						onChange={(e) => setFormData({ ...formData, number_of_people: parseInt(e.target.value) || '' })}
						// required
					/>
					<textarea 
						className="border p-3 rounded md:col-span-2" 
						placeholder="Questions or notes" 
						rows={3}
						value={formData.notes}
						onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
					/>
					<button 
						type="submit" 
						className="md:col-span-2 bg-indigo-600 text-white rounded p-3 disabled:opacity-50"
						disabled={loading}
					>
						{loading ? 'Submitting...' : 'Submit'}
					</button>
				</form>
			</div>
		</div>
	);
};

export default StudentInterest;


